import { firestore, firebaseApp } from '../main';
import firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    behaviours: [],
    selectedBehaviourBadges: [],
    selectedBehaviourAwards: [],
    awardsClaimedBy: {},
    isReceivingBadges: false,
    isReceivingAwards: false,
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null
  },
  mutations: {
    RECEIVED_BEHAVIOURS(state, payload) {
      state.behaviours = payload;
      state.isReceiving = false;
    },
    RECEIVING_BEHAVIOURS(state) {
      state.isReceiving = true;
    },
    RECEIVED_BEHAVIOUR_BADGES(state, payload) {
      state.selectedBehaviourBadges = payload;
      state.isReceivingBadges = false;
    },
    RECEIVED_BEHAVIOUR_AWARDS(state, payload) {
      state.selectedBehaviourAwards = payload;
      state.isReceivingAwards = false;
    },
    RECEIVING_BEHAVIOUR_BADGES(state) {
      state.isReceivingBadges = true;
    },
    RECEIVING_BEHAVIOUR_AWARDS(state) {
      state.isReceivingAwards = true;
    },
    UPDATED_BEHAVIOUR(state, payload) {
      let index = state.behaviours.findIndex(p => p.id === payload.id);
      if (index == -1) {
        state.behaviours = [...state.behaviours, payload];
      }
      state = Object.assign(state, {
        behaviours: state.behaviours.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_BEHAVIOUR(state) {
      state.isUpdating = true;
    },
    DELETED_BEHAVIOUR(state, payload) {
      let indexToDelete = state.behaviours.findIndex(p => p.id === payload.id);
      let behaviours = [...state.behaviours];
      behaviours.splice(indexToDelete, 1);
      state = Object.assign(state, {
        behaviours: [...behaviours],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_BEHAVIOUR(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
    SELECT_BEHAVIOUR(state, payload) {
      state.selectedBehaviour = payload;
    },
    RECEIVED_AWARDS_USER_CLAIMS(state, payload) {
      state.awardsClaimedBy = payload;
    },
    UPDATED_AWARDS_USER_CLAIMS(state, payload) {
      debugger;
      let claimedAwards = state.awardsClaimedBy;
      for (let i in claimedAwards[payload.awardId]) {
        if (claimedAwards[payload.awardId][i].awardHistoryId == payload.id) claimedAwards[payload.awardId][i].confirmed = payload.confirmed;
      }
      state.awardsClaimedBy = claimedAwards;
    }
  },
  actions: {
    selectBehaviour({ commit }, payload) {
      commit('SELECT_BEHAVIOUR', payload);
    },
    async saveBadgesForBehaviourRequest({ dispatch }, payload) {
      const behaviourRef = await firestore
        .collection('behaviours')
        .doc(payload.behaviourId)
        .set({ badgeIds: payload.badgesIds }, { merge: true });
      dispatch('getBadgesForBehaviour', payload.behaviourId);
      payload.$toasted.success('Behaviour badges have been updated!');
    },
    async saveAwardsForBehaviourRequest({ dispatch }, payload) {
      const awardIds = payload.awards.map(a => a.id);
      const behaviourRef = await firestore
        .collection('behaviours')
        .doc(payload.behaviourId)
        .set({ awards: payload.awards, awardIds: awardIds }, { merge: true });
      dispatch('getAwardsForBehaviour', payload.behaviourId);
      payload.$toasted.success('Behaviour awards have been updated!');
    },
    async getAwardsUserClaims({ dispatch }, payload) {
      const awardsHistorySnap = await firestore
        .collection('awards-history')
        .where('behaviourId', '==', payload.behaviourId)
        .where('awardId', 'in', payload.awardIds)
        .where('claimed', '==', true)
        .get();
      const awardsHistory = awardsHistorySnap.docs.map(a => Object.assign({}, a.data(), { id: a.id }));
      const userIds = awardsHistory.map(a => a.userId);

      const userSnap = await firestore
        .collection('users')
        .where(firebase.firestore.FieldPath.documentId(), 'in', userIds)
        .get();
      const usersData = {};
      userSnap.docs.forEach(u => {
        const user = u.data();
        let displayName = user.firstName ? user.firstName : '';
        displayName = user.lastName ? `${displayName} ${user.lastName}` : displayName;
        usersData[u.id] = {
          id: u.id,
          displayName: displayName,
          avatarUrl: user.avatarUrl
        };
      });

      let awardsClaimedBy = {};
      awardsHistory.forEach(a => {
        if (awardsClaimedBy[a.awardId] == null) {
          awardsClaimedBy[a.awardId] = [];
        }
        awardsClaimedBy[a.awardId].push(Object.assign({}, usersData[a.userId], { awardHistoryId: a.id, confirmed: a.confirmed }));
      });
      dispatch('receiveAwardsUserClaims', awardsClaimedBy);
    },
    async getBadgesForBehaviour({ dispatch }, behaviourId) {
      dispatch('receivingBehaviourBadges');
      const behaviourSnapshot = await firestore
        .collection('behaviours')
        .doc(behaviourId)
        .get();
      if (behaviourSnapshot.exists) {
        const behaviourData = behaviourSnapshot.data();
        const badgesIds = behaviourData.badgeIds;
        if (badgesIds != null && badgesIds.length > 0) {
          const badgesSnapshot = await firestore
            .collection('badges')
            .where(firebase.firestore.FieldPath.documentId(), 'in', badgesIds)
            .get();
          let badges = [];
          badgesSnapshot.docs.map(doc => badges.push(Object.assign({}, doc.data(), { id: doc.id })));
          dispatch('receiveBehaviourBadges', badges);
        } else {
          dispatch('receiveBehaviourBadges', []);
        }
      } else {
        dispatch('receiveBehaviourBadges', []);
      }
    },
    async getAwardsForBehaviour({ dispatch }, behaviourId) {
      dispatch('receivingBehaviourAwards');
      const behaviourSnapshot = await firestore
        .collection('behaviours')
        .doc(behaviourId)
        .get();
      if (behaviourSnapshot.exists) {
        const behaviourData = behaviourSnapshot.data();
        const awardIds = behaviourData.awardIds;
        const behaviourAwards = behaviourData.awards;
        if (awardIds != null && awardIds.length > 0) {
          const awardsSnapshot = await firestore
            .collection('awards')
            .where(firebase.firestore.FieldPath.documentId(), 'in', awardIds)
            .get();
          let awards = [];
          awardsSnapshot.docs.map(doc =>
            awards.push(
              Object.assign({}, doc.data(), {
                id: doc.id,
                startDate: behaviourAwards.filter(a => a.id == doc.id)[0].startDate,
                endDate: behaviourAwards.filter(a => a.id == doc.id)[0].endDate
              })
            )
          );
          dispatch('receiveBehaviourAwards', awards);
        } else {
          dispatch('receiveBehaviourAwards', []);
        }
      } else {
        dispatch('receiveBehaviourAwards', []);
      }
    },
    async getBehavioursRequest({ dispatch }, selectedCountry) {
      dispatch('receivingBehaviours');
      const countryBehaviours = await firestore
        .collection('behaviours')
        .where('tenantId', '==', selectedCountry)
        .get();
      const globalBehaviours = await firestore
        .collection('behaviours')
        .where('global', '==', true)
        .get();
      let behaviours = [];
      countryBehaviours.docs.map(doc => behaviours.push(Object.assign({}, doc.data(), { id: doc.id })));
      globalBehaviours.docs.map(doc => behaviours.push(Object.assign({}, doc.data(), { id: doc.id })));
      // const behaviours = countryBehaviours.docs.map(doc => Object.assign ({} , doc.data(), {id: doc.id}));
      dispatch('receiveBehaviours', behaviours);
    },
    async toggleBehaviourPublic({ dispatch }, payload) {
      dispatch('updatingBehaviour');
      const behaviourRef = await firestore
        .collection('behaviours')
        .doc(payload.id)
        .set({ public: payload.public }, { merge: true });
      const behaviourSnapshot = await firestore
        .collection('behaviours')
        .doc(payload.id)
        .get();
      payload.$toasted.success('Behaviour has been updated!');
      dispatch('updateBehaviour', Object.assign({}, behaviourSnapshot.data(), { id: payload.id }));
    },
    async updateBehaviourRequest({ dispatch }, payload) {
      dispatch('updatingBehaviour');
      const behaviourRef = await firestore
        .collection('behaviours')
        .doc(payload.id)
        .set(payload.behaviour, { merge: true });
      const behaviourSnapshot = await firestore
        .collection('behaviours')
        .doc(payload.id)
        .get();

      payload.$toasted.success('Behaviour has been updated!');
      dispatch('updateBehaviour', Object.assign({}, behaviourSnapshot.data(), { id: payload.id }));
    },
    async createBehaviourRequest({ dispatch }, payload) {
      dispatch('updatingBehaviour');
      const behaviourRef = await firestore.collection('behaviours').add(payload.behaviour);
      const behaviourSnapshot = await firestore
        .collection('behaviours')
        .doc(behaviourRef.id)
        .get();
      payload.$toasted.success('Behaviour has been created!');
      dispatch('updateBehaviour', Object.assign({}, behaviourSnapshot.data(), { id: behaviourRef.id }));
    },
    async markAwardAsOffered({ dispatch }, payload) {
      await firestore
        .collection('awards-history')
        .doc(payload.id)
        .update({
          confirmed: payload.confirmed
        });

      dispatch('updateAwardsUserClaims', { id: payload.id, confirmed: payload.confirmed, awardId: payload.awardId });
    },
    // async deleteBehaviourRequest({dispatch}, payload) {
    //   dispatch("deletingBehaviour", payload);
    //   console.log("DELETING BEHAVIOUR")
    //
    //   if(payload.id != null) {
    //     await firestore.collection("behaviours").doc(payload.id).delete()
    //     dispatch("deleteBehaviour", {id: payload.id});
    //     payload.$toasted.success("Behaviour has been deleted!");
    //   } else {
    //     dispatch("deleteBehaviour",{});
    //     payload.$toasted.error("Behaviour could not be deleted!");
    //   }
    // },
    receiveBehaviourBadges({ commit }, payload) {
      commit('RECEIVED_BEHAVIOUR_BADGES', payload);
    },
    receivingBehaviourBadges({ commit }) {
      commit('RECEIVING_BEHAVIOUR_BADGES');
    },
    receiveBehaviourAwards({ commit }, payload) {
      commit('RECEIVED_BEHAVIOUR_AWARDS', payload);
    },
    receivingBehaviourAwards({ commit }) {
      commit('RECEIVING_BEHAVIOUR_AWARDS');
    },
    receiveBehaviours({ commit }, payload) {
      commit('RECEIVED_BEHAVIOURS', payload);
    },
    receiveAwardsUserClaims({ commit }, payload) {
      commit('RECEIVED_AWARDS_USER_CLAIMS', payload);
    },
    updateAwardsUserClaims({ commit }, payload) {
      commit('UPDATED_AWARDS_USER_CLAIMS', payload);
    },
    receivingBehaviours({ commit }) {
      commit('RECEIVING_BEHAVIOURS');
    },
    updateBehaviour({ commit }, payload) {
      commit('UPDATED_BEHAVIOUR', payload);
    },
    updatingBehaviour({ commit }) {
      commit('UPDATING_BEHAVIOUR');
    },
    deleteBehaviour({ commit }, payload) {
      commit('DELETED_BEHAVIOUR', payload);
    },
    deletingBehaviour({ commit }, payload) {
      commit('DELETING_BEHAVIOUR', payload);
    }
  }
};
